import script from "./HrBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./HrBadge.vue?vue&type=script&setup=true&lang=js"

import "./HrBadge.vue?vue&type=style&index=0&id=07f9d552&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f9d552"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
